import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Building } from 'src/app/models/building.model';
import { Settlement } from 'src/app/models/settlement.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-form-order',
  template: `
    <form [formGroup]="formOrder" (ngSubmit)="saveorder()">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group required mb-4 mt-3">
            <label for="folio" class="form-label ms-2">Folio</label>
            <input type="text" class="form-control form-control-lg rounded-3" id="folio" placeholder="" formControlName="folio">
            <div *ngIf="ufc['folio'].touched && ufc['folio'].invalid">
              <div *ngIf="ufc['folio'].errors?.['required']" class="text-danger text-sm">El folio es requerido.</div>
            </div>
          </div>
          <div class="form-group mb-4 mt-3">
            <label for="description" class="form-label ms-2">Descripción</label>
            <input type="text" class="form-control form-control-lg rounded-3" id="description" placeholder="" formControlName="description">
            <div *ngIf="ufc['description'].touched && ufc['description'].invalid">
              <div *ngIf="ufc['description'].errors?.['required']" class="text-danger text-sm">La descripción es requerido.</div>
            </div>
          </div>
          <div class="form-group required mb-4 mt-3">
            <label for="liters" class="form-label ms-2">Litros solicitados</label>
            <input type="number" class="form-control form-control-lg rounded-3" id="liters" placeholder="" formControlName="liters">
            <div *ngIf="ufc['liters'].touched && ufc['liters'].invalid">
              <div *ngIf="ufc['liters'].errors?.['required']" class="text-danger text-sm">El precio es requerido.</div>
            </div>
          </div>
          <!-- div class="form-group required mb-4 mt-3">
            <label for="price" class="form-label ms-2">Precio Lt.</label>
            <input type="number" class="form-control form-control-lg rounded-3" id="price" placeholder="" formControlName="price">
            <div *ngIf="ufc['price'].touched && ufc['price'].invalid">
              <div *ngIf="ufc['price'].errors?.['required']" class="text-danger text-sm">El precio es requerido.</div>
            </div>
          </!-->
          <div class="form-group required mb-4 mt-3">
            <label for="name" class="form-label ms-2">Condominio</label>
            <select class="form-select form-select-lg rounded-3" formControlName="settlement_id" (change)="selectSettlement($event)">
              <option selected>Selecciona un condominio</option>
              <option *ngFor="let settlement of settlements" [value]="settlement!.id">{{ settlement.name }}</option>
            </select>
            <fa-icon [icon]="icons.faCircleNotch" size="1x" animation="spin" class="text-secondary" *ngIf="loading"></fa-icon>
          </div>
          <div class="form-group required mb-4 mt-3" *ngIf="buildings.length>0">
            <label for="name" class="form-label ms-2">Edificio</label>
            <select class="form-select form-select-lg rounded-3" (change)="selectBuilding($event)">
              <option selected>Selecciona un edificio</option>
              <option *ngFor="let building of buildings" [value]="building.id">{{ building.name }}</option>
            </select>
          </div>
          <div class="form-group required mb-4 mt-3" *ngIf="selectedBuilding.id">
            <label for="tanque_id" class="form-label ms-2">Tanque</label>
            <select class="form-select form-select-lg rounded-3" formControlName="tanque_id">
              <option selected>Selecciona un tanque</option>
              <option *ngFor="let tanque of selectedBuilding.tanques" [value]="tanque.id">{{ tanque.name }}</option>
            </select>
          </div>
          <div class="form-group required mb-0 mt-4 text-end">
            <button type="button" class="btn btn-link me-2" routerLink="/combustibles/orders">Cancelar</button>
            <button type="submit" class="btn btn-zazz-dark">
              <fa-icon [icon]="icons.faSave" class="me-2"></fa-icon>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </form>
  `,
  styleUrls: []
})
export class FormOrderComponent {
  @Input() order: any = {};
  @Input() loading: boolean = false;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() orderData = new EventEmitter<any>();

  formOrder: FormGroup = new FormGroup({});

  settlements: Settlement[] = [];
  buildings: Building[] = [];
  selectedBuilding: any = {};

  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public icons: IconsService
  ) {         
    
  } 

  get ufc() {
    return this.formOrder.controls;
  }

  ngOnInit(): void {
    this.initForm();
    this.loadSettlements();    
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes['order'].currentValue) {
      this.formOrder.patchValue(changes['order'].currentValue);
      this.preFill();
    }
  }

  initForm() {
    this.formOrder = this.fb.group({
      folio: ['', Validators.required],
      description: ['', Validators.required],
      // price: ['', Validators.required],
      liters: ['', Validators.required],
      status: false,
      tanque_id: ['', Validators.required],
      settlement_id: [''],
    });
  }

  loadSettlements() {
    this.store.getSettlements({
      page: 1,
      per_page: 1000,
      proutility_id: this.profile.id
    }).subscribe({
      next: (stl: any) => {
        this.settlements = stl.data;
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Ocurrió un error al obtener los condominios.');
      }
    });
  }

  preFill() {
    console.log(this.order);
    if (this.order.settlement) {
      console.log("this.order.settlement.id");
      console.log(this.order.settlement);
      this.formOrder.patchValue({
        settlement_id: this.order.settlement.id
      });
      this.store.getBuildingsBySettlement(this.order.settlement.id).subscribe({
        next: (data) => {
          console.log(data);
          
          this.buildings = data;
          if (this.order.building) {
            this.formOrder.patchValue({
              building_id: this.order.building.id
            });
          }
        },
        error: (err) => {
          console.log(err);
        }
      });
    }
  }

  selectSettlement(e: any) {
    console.log('selectSettlement');
    console.log(e.target.value);
    this.store.getBuildingsBySettlement(e.target.value).subscribe({
      next: (data) => {
        console.log(data);
        this.buildings = data;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  selectBuilding(e: any) {
    console.log('selectBuilding');
    console.log(e.target.value);
    let xx = this.buildings.filter((building: any) => { 
      console.log('guilding.id == <', building.id);
      return building.id == e.target.value;
    })[0];
    console.log(xx);
    this.selectedBuilding = xx; 
  }

  saveorder() {
    console.log(this.formOrder.value);

    if (this.formOrder.invalid) {
      this.formOrder.markAllAsTouched();
      this.toastr.error('Formulario inválido.', 'Error');
      return;
    }

    this.orderData.emit(this.formOrder.value);    
  }
}
